/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { cliproBadgesStateUpdate } from '../fn/clipro/clipro-badges-state-update';
import { CliproBadgesStateUpdate$Params } from '../fn/clipro/clipro-badges-state-update';
import { cliproTransactionCreate } from '../fn/clipro/clipro-transaction-create';
import { CliproTransactionCreate$Params } from '../fn/clipro/clipro-transaction-create';


/**
 * APIs made to be called by CLIPRO partner, mainly about badges and transactions
 */
@Injectable({ providedIn: 'root' })
export class CliproService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `cliproTransactionCreate()` */
  static readonly CliproTransactionCreatePath = '/custom/clipro/transaction';

  /**
   * CLIPRO can send us transaction creation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cliproTransactionCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cliproTransactionCreate$Response(params: CliproTransactionCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return cliproTransactionCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * CLIPRO can send us transaction creation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cliproTransactionCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cliproTransactionCreate(params: CliproTransactionCreate$Params, context?: HttpContext): Observable<void> {
    return this.cliproTransactionCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `cliproBadgesStateUpdate()` */
  static readonly CliproBadgesStateUpdatePath = '/custom/clipro/badges/state/update';

  /**
   * CLIPRO can send us update about the badges status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cliproBadgesStateUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cliproBadgesStateUpdate$Response(params: CliproBadgesStateUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return cliproBadgesStateUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * CLIPRO can send us update about the badges status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cliproBadgesStateUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cliproBadgesStateUpdate(params: CliproBadgesStateUpdate$Params, context?: HttpContext): Observable<void> {
    return this.cliproBadgesStateUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
